import { render } from "./ButhiHeader.vue?vue&type=template&id=781c5688&scoped=true"
import script from "./ButhiHeader.vue?vue&type=script&lang=js"
export * from "./ButhiHeader.vue?vue&type=script&lang=js"

import "./ButhiHeader.vue?vue&type=style&index=0&id=781c5688&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\wkphi\\Desktop\\Programming\\buthigame - Copy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781c5688"]])

export default __exports__